import { createAction, props } from '@ngrx/store';
import { ApiPagingConfig } from 'src/app/shared/models/paging/ApiPagingConfig';
import { GlobalSearchResult } from 'src/app/shared/models/global-search/GlobalSearchResult';
import { GlobalSearchResults } from 'src/app/shared/models/global-search/GlobalSearchResults';

export const GlobalSearchActionTypes = {
  SEARCH: '[GLOBAL_SEARCH] Search',
  SEARCH_SUCCESS: '[GLOBAL_SEARCH] Search success',
  SEARCH_ERROR: '[GLOBAL_SEARCH] Search error',
  SET_VISIBLE: '[GLOBAL_SEARCH] visible',
};

export const GlobalSearchAction = createAction(
  GlobalSearchActionTypes.SEARCH,
  props<{ searchQuery: string; pagingConfig: ApiPagingConfig }>()
);
export const GlobalSearchSuccessAction = createAction(
  GlobalSearchActionTypes.SEARCH_SUCCESS,
  props<{
    searchResults: GlobalSearchResults;
  }>()
);
export const GlobalSearchErrorAction = createAction(
  GlobalSearchActionTypes.SEARCH_ERROR,
  props<{}>()
);

export const SetSearchResultsVisible = createAction(
  GlobalSearchActionTypes.SET_VISIBLE,
  props<{visible: boolean}>()
);
